import { useSyncExternalStore } from 'react';
import { subscribeToNothing } from '../../utils/subscribeToNothing/subscribeToNothing';

export const useIsHydrated = () => {
  const isHydrated = useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false,
  );

  return { isHydrated };
};
